"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var tokens_1 = require("../../tokens");
var icons_json_1 = __importDefault(require("./icons.json"));
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var icons = icons_json_1.default.icons;
var Icon = function (props) {
    var icon = icons[props.name] || icons.help;
    var color = tokens_1.colors.base[props.color] || props.color;
    return (React.createElement(Icon.Element, __assign({}, automation_attribute_1.default('icon'), props),
        React.createElement(Image, { width: props.size, height: props.size, viewBox: "0 0 " + icon.width + " " + icon.height, color: color }, icon.paths.map(function (path, index) { return (React.createElement("path", { key: index, d: path })); }))));
};
Icon.Element = styled_1.default.i(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  line-height: 1;\n  width: ", "px;\n  height: ", "px;\n"], ["\n  display: inline-block;\n  line-height: 1;\n  width: ", "px;\n  height: ", "px;\n"])), function (props) { return props.size; }, function (props) { return props.size; });
var Image = styled_1.default.svg(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 1;\n  width: ", "px;\n  height: ", "px;\n  path {\n    fill: ", ";\n  }\n"], ["\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 1;\n  width: ", "px;\n  height: ", "px;\n  path {\n    fill: ", ";\n  }\n"])), function (imageProps) { return imageProps.width; }, function (imageProps) { return imageProps.height; }, function (imageProps) { return imageProps.color; });
var __ICONNAMES__ = Object.keys(icons);
exports.__ICONNAMES__ = __ICONNAMES__;
var __COLORS__ = Object.keys(tokens_1.colors.base);
Icon.defaultProps = {
    size: 20,
    color: 'default'
};
exports.default = Icon;
var templateObject_1, templateObject_2;
//# sourceMappingURL=icon.js.map